import { render, staticRenderFns } from "./activity.vue?vue&type=template&id=56d2d176&scoped=true&"
import script from "./activity.ts?vue&type=script&lang=ts&"
export * from "./activity.ts?vue&type=script&lang=ts&"
import style0 from "./activity.scss?vue&type=style&index=0&id=56d2d176&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d2d176",
  null
  
)

export default component.exports